/* ============================================================
   KAIJU KROSSING — theme.js
   ============================================================ */

// ── Brand icon (怪 kanji) ──
(function() {
  var el = document.createElement('link');
  el.rel = 'icon';
  el.type = 'image/svg+xml';
  el.href = 'https://' + (window.Shopify && Shopify.cdnHost ? Shopify.cdnHost : 'kaijukrossing.com/cdn') + '/shop/t/5/assets/favicon.svg';
  document.head.appendChild(el);
})();

// ── Scroll reveal ──
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('on');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ── AJAX Add to Cart ──
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-add-to-cart], .rc-add-btn, .pc-cta-btn, .ec-cta-btn, .rel-cta-btn');
  if (!btn) return;

  const productId = btn.dataset.productId;
  if (!productId || btn.disabled) return;

  e.preventDefault();
  btn.disabled = true;
  btn.textContent = '…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(productId), quantity: 1 })
    });

    if (res.ok) {
      btn.textContent = '✓';
      btn.style.background = 'var(--showa-g)';
      btn.style.color = 'var(--void)';

      // Update cart count in nav
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('.nav-cart').forEach(link => {
          const count = cart.item_count;
          link.textContent = count > 0 ? `Cart (${count})` : 'Cart';
        });
      } catch (_) { /* cart count update is non-critical */ }

      setTimeout(() => {
        btn.textContent = btn.dataset.label || '→';
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 1500);
    } else {
      const data = await res.json().catch(() => ({}));
      btn.textContent = data.description || 'Error';
      btn.style.background = 'var(--showa-r)';
      setTimeout(() => {
        btn.textContent = btn.dataset.label || '→';
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    }
  } catch (err) {
    btn.textContent = 'Offline';
    btn.style.background = 'var(--showa-r)';
    setTimeout(() => {
      btn.textContent = btn.dataset.label || '→';
      btn.style.background = '';
      btn.style.color = '';
      btn.disabled = false;
    }, 2000);
  }
});

// ── Mobile nav toggle ──
const mobileMenuBtn = document.querySelector('.nav-menu-toggle');
const mobileMenu = document.querySelector('.nav-pills-mobile');
if (mobileMenuBtn && mobileMenu) {
  mobileMenuBtn.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('open');
    mobileMenuBtn.classList.toggle('open');
    mobileMenuBtn.setAttribute('aria-expanded', isOpen);
  });
  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      mobileMenuBtn.classList.remove('open');
      mobileMenuBtn.setAttribute('aria-expanded', 'false');
    });
  });
}

// ── Game callout tracking ──
document.querySelectorAll('.hero-game-callout').forEach(function(el) {
  el.addEventListener('click', function() {
    var title = el.querySelector('.hgc-title');
    var name = title ? title.textContent.replace(/\s+/g, ' ').trim() : 'unknown';
    if (typeof gtag === 'function') {
      gtag('event', 'game_click', {
        game_name: name,
        click_location: 'hero'
      });
    }
  });
});

// ── Announcement bar dismiss ──
const announcementClose = document.querySelector('.announcement-close');
const announcementBar   = document.querySelector('.announcement-bar');
if (announcementClose && announcementBar) {
  announcementClose.addEventListener('click', () => {
    announcementBar.style.display = 'none';
    sessionStorage.setItem('kaiju-announcement-dismissed', '1');
  });
  if (sessionStorage.getItem('kaiju-announcement-dismissed')) {
    announcementBar.style.display = 'none';
  }
}
